import React from 'react';
import { Portal } from 'react-portal';

import PropTypes from 'prop-types';

const ModalComponent = ({ extraStyles, className, handleClick, children }) => (
  <Portal>
    <div className="fixed inset-0 z-[9999] flex items-center justify-center overflow-auto min-h-screen">
      <div className="absolute inset-0 bg-black/[0.85] z-10" onClick={handleClick} />
      <div
        className={`relative p-6 bg-white rounded-[4px] shadow-[0_10px_20px_rgba(0,0,0,0.19),0_6px_6px_rgba(0,0,0,0.23)] z-20 ${className ? className : 'w-[95%] max-w-[760px]'}`}
        style={extraStyles}
      >
        {children}
      </div>
    </div>
  </Portal>
);

ModalComponent.propTypes = {
  handleClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  extraStyles: PropTypes.object,
  className: PropTypes.string,
};

ModalComponent.defaultProps = {
  extraStyles: null,
  className: '',
};

export default ModalComponent;
